import { Box, Typography, SxProps } from '@mui/material';
import { useStyles } from './styles';
import { IPageSubtitleContent } from './interfaces';

const PageSubtitleContent = ({
  subtitle = '',
  text = '',
  forceKeepSubtitle = false,
  sx = {},
}: IPageSubtitleContent) => {
  const classes = useStyles();

  return (
    <Box sx={{ ...classes.root, ...sx } as SxProps}>
      {subtitle && (
        <Typography sx={classes.subtitle(forceKeepSubtitle)}>
          {subtitle}
        </Typography>
      )}
      {text && (
        <Typography sx={classes.text(forceKeepSubtitle)}>{text}</Typography>
      )}
    </Box>
  );
};

export default PageSubtitleContent;
